import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

// Fade + rise on scroll into view
export function Reveal({ children, delay = 0, y = 28, className = "", once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-10% 0px -10% 0px" }}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}

// Masked line-by-line heading reveal. `lines` = array of strings.
export function MaskText({
  lines,
  className = "",
  delay = 0,
  stagger = 0.09,
  once = true,
  as: Tag = "h2",
}) {
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <span className="mask-line" key={i}>
          <motion.span
            style={{ display: "block", willChange: "transform" }}
            initial={{ y: "110%" }}
            whileInView={{ y: "0%" }}
            viewport={{ once, margin: "-8% 0px" }}
            transition={{ duration: 1, ease: EASE, delay: delay + i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}
